import { Button } from '@/common/components/Button.tsx'
import { cn } from '@/common/utilities.ts'
import { useWizardContext } from '@/app/pages/program_applications/vendor_application/WizardProvider.tsx'
import { useMatch } from 'react-router-dom'
import { AppRoutePaths } from '@/routing/route_paths.ts'
import { useTranslation } from 'react-i18next'

type WizardFooterProps = {
  onNext: () => void
  nextButtonText?: string
}

export const WizardFooter = ({
  onNext = () => {},
  nextButtonText,
}: WizardFooterProps) => {
  const { t: translate } = useTranslation()
  const { goBack } = useWizardContext()
  const locationIsChecklist = useMatch(
    AppRoutePaths.program_application.wizard.index
  )

  return (
    <div className="flex justify-between my-10 mx-6">
      <Button
        onClick={goBack}
        className={cn('px-10 ', {
          hidden: locationIsChecklist != null,
        })}
        variant="outline"
      >
        {translate('back')}
      </Button>
      <div className="flex items-center gap-4 ml-auto">
        <Button className={cn('whitespace-nowrap')} variant="soft">
          {translate('save_and_exit')}
        </Button>

        <Button onClick={onNext} className={cn('px-10')}>
          {nextButtonText ? nextButtonText : translate('next')}
        </Button>
      </div>
    </div>
  )
}
